import jsonpath from 'jsonpath';
const flags = require('../flags.json');

export default class Flag {
  public static hasFeature(flag: string) {
    const obj = jsonpath.query(flags, flag);
    if (obj.length === 0) { return false; }
    const doc = obj[0];
    if (typeof doc === 'boolean') {
      return doc;
    }
    if ('_enabled' in doc) {
      // eslint-disable-next-line no-underscore-dangle
      return doc._enabled;
    }

    const inferedflag = new Set(jsonpath.query(doc, '$..*'));
    if (inferedflag.has(true)) {
      return true;
    }


    return false;
  }

  private static flagged(flag: string) {
    return flags[flag];
  }

  public static getFlags(): any {
    const { origin } = window.location;

    const ENV_MAP: Record<string, string> = {
      'https://dev.foodworks.org': 'dev',
      'https://staging.foodworks.org': 'staging',
      'https://app.foodworks.org': 'v1',
    };

    const env = ENV_MAP[origin] || 'dev';
    const clonedFlags = JSON.parse(JSON.stringify(flags));

    if (clonedFlags.market.scheduler_enabled[env]) {
      clonedFlags.market.scheduler_enabled = clonedFlags.market.scheduler_enabled[env];
    } else {
      clonedFlags.market.scheduler_enabled = [];
    }

    return clonedFlags;
  }
}
